export default __webpack_public_path__ + "static/media/a2.66523e82.png";